
window.addEventListener('load', () => {
    let attempts = 0;
    const maxAttempts = 600; // 600 attempts = 10 seconds at 60 FPS

    // Use MutationObserver to listen for changes in the DOM
    const observer = new MutationObserver(() => {
        const popover = document.querySelector('.pop-in.newsletter-popup');
        const chatButton = document.querySelector('.umm-1pktds7');

        if (popover && chatButton) {
            // Start observing changes in the popover's styles
            const styleObserver = new MutationObserver(() => {
                if (getComputedStyle(popover).display === 'block') {
                    chatButton.style.setProperty('display', 'none', 'important');
                } else {
                    chatButton.style.setProperty('display', 'flex', 'important');
                }
            });

            // Observe attribute and DOM structure changes
            styleObserver.observe(popover, { 
                attributes: true, 
                childList: true, 
                subtree: true 
            });

            // Stop the observer once the elements are found
            observer.disconnect();
        }
    });

    // Keep checking the DOM until elements are found
    observer.observe(document.body, { 
        childList: true, 
        subtree: true 
    });

    // Function to monitor popup visibility and button state
    function checkPopup() {
        const popover = document.querySelector('.pop-in.newsletter-popup');
        const chatButton = document.querySelector('.umm-1pktds7');

        if (popover && chatButton) {
            if (getComputedStyle(popover).display === 'block') {
                chatButton.style.setProperty('display', 'none', 'important');
            } else {
                chatButton.style.setProperty('display', 'flex', 'important');
            }
        }

        attempts++;
        if (attempts < maxAttempts) {
            // Continue checking only if elements are in the DOM and attempts limit is not reached
            requestAnimationFrame(checkPopup);
        }
    }

    requestAnimationFrame(checkPopup);
});

